import { configureStore, createListenerMiddleware } from '@reduxjs/toolkit';
import rootReducer from './reducers/';
//services
import { togglePage } from './reducers/ui.reducers';

// Create the middleware instance and methods
const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
	actionCreator: togglePage,
	effect: async () => {},
});

export const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({ serializableCheck: false }).prepend(listenerMiddleware.middleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
